import React, { useEffect, useState } from "react";
import axios from "axios";
import { all_routes } from "../router/all_routes";
import Breadcrumb from "../../core/common/Breadcrumb/breadcrumb";
import DriverSidebar from "./sidebar";
import DriverBookingCard from "./components/DriverBookingCard";

const DriverTours = () => {
    const routes = all_routes;
    const [tours, setTours] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    // 🔹 Filtros
    const [statusFilter, setStatusFilter] = useState<string>("");
    const [dateFilter, setDateFilter] = useState<string>("");

    // 🔹 Paginação
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 4;

    const BASE_URL = process.env.REACT_APP_API_URL;
    const token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };

    const breadcrumbs = [
        { label: "Dashboard", link: routes.driverDashboard, active: false },
        { label: "Meus Tours", active: true },
    ];

    const fetchTours = async () => {
        setLoading(true);
        if (!token) return;

        try {
            const params: any = {};
            if (statusFilter) params.status = statusFilter;
            if (dateFilter) params.data = dateFilter;

            // 🔹 Pega os tours do motorista
            const toursRes = await axios.get(`${BASE_URL}/motorista/tours`, {
                headers,
                params,
            });
            const toursData = toursRes.data;

            // 🔹 Pega todas as mensagens não vistas por compra de uma vez
            const unreadRes = await axios.get<{ compraId: number; naoVisualizadas: number }[]>(
                `${BASE_URL}/motorista/mensagens/nao-visualizadas-por-compra`,
                { headers }
            );

            // 🔹 Cria um Map para associar cada compraId ao número de mensagens não visualizadas
            const unreadMap = new Map<number, number>();
            unreadRes.data.forEach(u => unreadMap.set(u.compraId, u.naoVisualizadas));

            // 🔹 Mescla o unreadCount nos tours
            const toursWithUnread = toursData.map((tour: any) => ({
                ...tour,
                unreadCount: unreadMap.get(tour.compraId) || 0,
            }));

            setTours(toursWithUnread);
        } catch (err) {
            console.error("Erro ao buscar tours:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTours();
    }, [statusFilter, dateFilter, BASE_URL]);

    // 🔹 Paginação
    const indexOfLast = currentPage * itemsPerPage;
    const indexOfFirst = indexOfLast - itemsPerPage;
    const currentItems = tours.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(tours.length / itemsPerPage);

    return (
        <div>
            <Breadcrumb
                title="Meus Tours"
                breadcrumbs={breadcrumbs}
                backgroundClass="breadcrumb-bg-01"
            />

            <div className="content">
                <div className="container">
                    <div className="row">
                        {/* Sidebar do motorista */}
                        <div className="col-xl-3 col-lg-4">
                            <DriverSidebar />
                        </div>

                        <div className="col-xl-9 col-lg-8">
                            <div className="card shadow-none mb-3">
                                <div className="card-header d-flex flex-wrap align-items-center justify-content-between">
                                    <h6 className="mb-2 mb-lg-0">Scheduled Tours</h6>
                                    <div className="d-flex flex-wrap gap-2">
                                        {/* 🔹 Filtro por status */}
                                        <select
                                            className="form-select form-select-sm"
                                            value={statusFilter}
                                            onChange={(e) => setStatusFilter(e.target.value)}
                                        >
                                            <option value="">All statuses</option>
                                            <option value="PENDENTE">Pending</option>
                                            <option value="PAGO">Paid</option>
                                            <option value="CANCELADO">Canceled</option>
                                        </select>

                                        {/* 🔹 Filtro por data */}
                                        <input
                                            type="date"
                                            className="form-control form-control-sm"
                                            value={dateFilter}
                                            onChange={(e) => setDateFilter(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="card-body">
                                    {loading ? (
                                        <div className="text-center py-5">
                                            <div className="spinner-border text-primary" role="status" />
                                            <p className="mt-3">Carregando tours...</p>
                                        </div>
                                    ) : tours.length === 0 ? (
                                        <div className="alert alert-info">
                                            Nenhum tour atribuído até o momento.
                                        </div>
                                    ) : (
                                        <>
                                            {currentItems.map((tour) => (
                                                <DriverBookingCard
                                                    key={tour.compraId}
                                                    compraId={tour.compraId}
                                                    status={tour.status}
                                                    dataReserva={tour.dataReserva}
                                                    horaReserva={tour.horaReserva}
                                                    precoTotal={tour.precoTotal}
                                                    adultos={tour.adultos}
                                                    criancas={tour.criancas}
                                                    quantidadePessoas={tour.quantidadePessoas}
                                                    pacote={{
                                                        id: tour.pacote?.id,
                                                        titulo: tour.pacote?.titulo,
                                                        duracaoEmMinutos: tour.pacote?.duracaoEmMinutos,
                                                        primeiraFotoId: tour.pacote?.primeiraFotoId,
                                                    }}
                                                    qrCodeMotorista={tour.qrCodeMotorista}
                                                    unreadCount={tour.unreadCount} // 🔹 Badge de mensagens
                                                />
                                            ))}

                                            {/* 🔹 Paginação */}
                                            <nav className="mt-4">
                                                <ul className="pagination justify-content-center">
                                                    {[...Array(totalPages)].map((_, index) => (
                                                        <li
                                                            key={index}
                                                            className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                                                        >
                                                            <button
                                                                className="page-link"
                                                                onClick={() => setCurrentPage(index + 1)}
                                                            >
                                                                {index + 1}
                                                            </button>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </nav>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                        {/* /Driver Tours */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DriverTours;